export default{label:"w_Cl",checked:"w_Cm",disabled:"w_Cn",input:"w_Co",radioInput:"w_Cp",radioInputOuter:"w_Cq",radioInputInner:"w_Cr",labelText:"w_Cs"};
